




import Vue from 'vue'
import Component from 'vue-class-component'

@Component<PDFFile>({
  props: {
    color1: {
      type: String,
      default : "#f40f02"
    }
  }
})

export default class PDFFile extends Vue {
  /**
   * Props variables
   */
  color1: string | undefined
  color2: string | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
